import React from "react";
import { observer } from "mobx-react";
import { AdminCertifiedModeListTemplate } from "themes/administration/certified-mode/pages";
import { AdminCertifiedModeListViewStore } from "administration/certified-mode/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new AdminCertifiedModeListViewStore(rootStore, componentProps),
    "adminCertifiedModeListViewStore"
)
@observer
class AdminCertifiedModeList extends React.Component {
    render() {
        return <AdminCertifiedModeListTemplate {...this.props} />;
    }
}

export default AdminCertifiedModeList;
